import React from 'react';

import FileViewer from '../../../components/FileViewer';
import { useFormSelector } from '../../../custom-hooks';
import { isTrue } from '../../../utils/commonUtils';
import { FORM_MODEL_ATTRIBUTES } from '../../constants/form-manager.constants';
import {
  getEvaluatedConditions,
  getEvaluatedExpression,
} from '../../selectors/form-manager.selectors';
import { getFileViewerParams } from '../../selectors/runtime.selectors';

const MIN_HEIGHT = 720;

const SSRuntimeFileViewer = ({
  entityName,
  documentRecordId,
  label,
  documentNumber,
  documentRevision,
  isDocumentContent,
  isPortalContent,
  id,
  index,
}) => {
  const documentParams = useFormSelector(getFileViewerParams, {
    documentRecordId,
    documentNumber,
    documentRevision,
  });
  const getLatestRevision = useFormSelector(getEvaluatedConditions, {
    id,
    index,
    entityName,
    prop: FORM_MODEL_ATTRIBUTES.LATEST_REVISION,
  });
  const contentType = useFormSelector(getEvaluatedExpression, {
    id,
    index,
    entityName,
    prop: FORM_MODEL_ATTRIBUTES.CONTENT_TYPE,
  });

  const params = {
    ...documentParams,
    contentType,
    entityKey: entityName,
    getLatestRevision,
    isDocumentContent: isTrue(isDocumentContent),
    isPortalContent: isTrue(isPortalContent),
  };

  return (
    <div data-ss-id={id}>
      <FileViewer params={params} height={MIN_HEIGHT} label={label} />
    </div>
  );
};

export default SSRuntimeFileViewer;
